import { Injectable } from '@angular/core';
import { ListHelperService, ProfileService, StoreService } from 'core/services';
import { TranslateService } from '@ngx-translate/core';
import { TableDatasource, DataTypes } from '@gamelearn/skeletor/models';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';
import { MarsLicenseService } from 'app/mars/services/mars-licenses.service';
import { Cache } from 'core/models';

@Injectable()
export class MarsLicenseProgressListService {
  userRole: any;
  constructor(
    public translate: TranslateService,
    public profileService: ProfileService,
    public listHelper: ListHelperService,
    public marsLicenseListService: MarsLicenseService,
    public router: Router
  ) {
    profileService.getLoggedUserRole$().subscribe((userRole) => (this.userRole = userRole));
  }

  async getDatasource(listId, options: any = {}, license) {
    const sessionsCache = new Cache(this.mapSessions(license));
    const dataSource = new TableDatasource({
      sort: 'index',
      columns: await this.getColumns(),
      load: (props) => sessionsCache.fetch(props),
      storeState: {
        enabled: true,
        key: `${listId}_${this.userRole.name}`
      },
      ...options
    });
    await dataSource.refreshData();
    StoreService.create(listId, dataSource);
    return dataSource;
  }

  mapSessions(license: any) {
    return license.sessions.map((session) => ({
      ...session,
      userEmail: license.userEmail
    }));
  }

  getColumns() {
    const columns = [
      {
        source: 'userEmail',
        style: { width: '150px' },
        label: this.translate.instant('nouns.email'),
        sortable: false
      },

      {
        source: 'startDate',
        style: { width: '140px' },
        label: this.translate.instant('reports.firstConnection'),
        sortable: true,
        dataType: DataTypes.datetime,
        valueParser: (value, license) => {
          const format = DateTime.DATETIME_MED_WITH_SECONDS;
          return this.listHelper.parseDate(value, license.timezone, format);
        }
      },
      {
        source: 'endDate',
        style: { width: '140px' },
        label: this.translate.instant('reports.lastConnection'),
        sortable: true,
        valueParser: (value, license) => {
          const format = DateTime.DATETIME_MED_WITH_SECONDS;
          return this.listHelper.parseDate(value, license.timezone, format);
        }
      },
      {
        source: 'accumulatedPoints',
        style: { width: '140px' },
        label: this.translate.instant('mars.totalPopulation'),
        sortable: true,
        valueParser: (value) => {
          return value == null ? '' : '' + value;
        }
      },
      {
        source: 'session',
        style: { width: '80px' },
        label: this.translate.instant('mars.sessions'),
        sortable: true,
        valueParser: (value) => {
          return value == null ? '' : '' + (value + 1);
        }
      },
      {
        source: 'turn',
        style: { width: '80px' },
        label: this.translate.instant('reports.level'),
        sortable: true,
        valueParser: (value) => {
          return value == null ? '' : '' + (value + 1);
        }
      },
      {
        source: 'gameProgress',
        style: { width: '80px' },
        label: this.translate.instant('reports.gameProgress'),
        sortable: true,
        valueParser: (value, license) => {
          const progress = license.values?.gameProgress ? Math.round(license.values.gameProgress) : 0;
          return progress + '%';
        }
      }
    ];
    return columns.filter((col) => col !== null);
  }
}
